export const sql = {
  render: 'SqlHighlight',
  attributes: {
    content: { type: String, required: true },
  },
};
